import AtomH3 from "Components/Atoms/H3";
import AtomNowTileImage from "Components/Atoms/NowTileImage";
import styled, { css } from "styled-components";

import * as Types from "Types";

const Wrap = styled.div<any>`
   ${({ css }) => css}
`;
const RectWrap = styled.div<Types.Default>`
   position: relative;
   cursor: pointer;
   width: 390px;
   height: 240px;
   max-width: 100%;
   overflow: hidden;
   ${({ css }) => css}
`;

const WrapText = styled.div`
   display: flex;
   position: absolute;
   width: 100%;
   height: 100%;
   justify-content: center;
   align-items: center;
   background-color: rgba(0, 0, 0, 0.5);
   transition-duration: 0.3s;
   transition-property: background-color;
   transition-timing-function: ease-in-out;
   ${RectWrap}:hover & {
      background-color: rgba(82, 0, 187, 0.8);
   }
`;

const Comment = styled.div`
   margin-top: 7px;
   font-weight: 400;
   font-size: 16px;
   line-height: 23px;
   letter-spacing: -0.02em;

   &::before {
      content: "";
      display: inline-block;
      border-left: 8px solid #c4c4c4;
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      margin-top: 7px;
      margin: 0 5px;
   }
`;

const cssImage = css`
   position: absolute;
   left: 0;
   top: 0;
   width: 100%;
   height: 100%;
   object-fit: cover;
`;

const cssH3 = css`
   color: #fff;
`;

export default function NowTile(props: any) {
   // uriTitle: string;
   return (
      <Wrap css={props.css}>
         <RectWrap>
            <AtomNowTileImage css={cssImage} src={props.thumbnailUri}></AtomNowTileImage>
            <WrapText>
               <AtomH3 css={cssH3}>{props.title}</AtomH3>
            </WrapText>
         </RectWrap>
         <Comment>{props.subtitle}</Comment>
      </Wrap>
   );
}
